"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedInvoiceAllowedPaymentProviderResponse = exports.mockedInvoiceAllowedPaymentProviderCreateRequest = void 0;
const common_interfaces_1 = require("../../common-interfaces");
const payment_provider_1 = require("../payment-provider");
exports.mockedInvoiceAllowedPaymentProviderCreateRequest = {
  paymentProviderId: 1,
  currency: common_interfaces_1.Currency.euro
};
exports.mockedInvoiceAllowedPaymentProviderResponse = {
  id: 1,
  paymentProvider: payment_provider_1.mockedPaypalPaymentProvider,
  currency: common_interfaces_1.Currency.euro
};